<mat-card>
  <mat-card-header>
    <mat-card-title>Configuración de Libreta</mat-card-title>
    <mat-card-subtitle style="font-size:1em">
      @if (report) {
        {{ report.name }}
      }
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <button mat-raised-button color="primary" (click)="newArea()">
      <mat-icon>add</mat-icon>Nueva área
    </button>
    <br><br>
    <div *ngFor="let area of listOfAreas$ | async">
      <span style="cursor: pointer;" (click)="updateArea(area.id)">{{ area.name }} </span>
      <button mat-mini-fab color="primary" (click)="newItem(area.id)" title="Agregar item">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-mini-fab color="warn" (click)="deleteArea(area.id)" title="Eliminar item">
        <mat-icon>delete</mat-icon>
      </button>

      <app-area-item [areaId]="area.id"></app-area-item>
    </div>

  </mat-card-content>
</mat-card>


<ng-template #loading>
  Cargando ...
</ng-template>
